module.exports = __webpack_public_path__ + "static/map-eeca547d0260eb05a0a3e9be98a88a00.jpg";